<div class="ticket-page">
  <nav class="ticket-tools">
    <span>{{ "RESERVATION_TICKET.HEADER" | translate }}</span
    ><select
      [ngModel]="language"
      (ngModelChange)="translate.use($event)"
      [attr.aria-label]="'MARKETING.LANGUAGE' | translate"
    >
      <option value="tr">Türkçe</option>
      <option value="en">English</option>
      <option value="de">Deutsch</option>
      <option value="es">Español</option>
      <option value="el">Ελληνικά</option>
    </select>
  </nav>
  @if (loading) {
  <p class="ticket-state" role="status">
    {{ "RESERVATION_TICKET.LOADING" | translate }}
  </p>
  } @if (error) {
  <section class="ticket-state" role="alert">
    <h1>{{ "RESERVATION_TICKET.UNAVAILABLE" | translate }}</h1>
    <p>{{ "RESERVATION_TICKET.ERROR" | translate }}</p>
    <button type="button" (click)="load()">
      {{ "CUSTOMERS.REFRESH" | translate }}
    </button>
  </section>
  } @if (ticket && !loading) { @if (action==='view') {
  <article class="reservation-pass">
    <header>
      <app-business-logo
        [tenantId]="ticket.user_id"
        [label]="ticket.company_name"
        [centered]="true"
      ></app-business-logo>
      <p class="eyebrow">
        {{
          (ticket.company_type === "defaultplus"
            ? "RESERVATION_TICKET.APPOINTMENT"
            : "RESERVATION_TICKET.RESERVATION"
          ) | translate
        }}
      </p>
      <h1>{{ ticket.company_name }}</h1>
      <span
        class="ticket-status"
        [class.cancelled]="statusKey === 'cancelled'"
        >{{ "RESERVATION_TICKET.STATES." + statusKey | translate }}</span
      >
    </header>
    <section class="pass-body">
      <div class="when">
        <div>
          <span>{{ "RESERVATION_TICKET.DATE" | translate }}</span
          ><strong>{{
            ticket.date | date : "EEEE, d MMMM yyyy" : undefined : language
          }}</strong>
        </div>
        <div>
          <span>{{ "RESERVATION_TICKET.TIME" | translate }}</span
          ><strong>{{ ticket.time }}</strong>
        </div>
      </div>
      <dl>
        @if (ticket.name) {
        <div>
          <dt>{{ "CUSTOMERS.NAME" | translate }}</dt>
          <dd>{{ ticket.name }}</dd>
        </div>
        }@if (ticket.num_people) {
        <div>
          <dt>{{ "RESERVATION_TICKET.GUESTS" | translate }}</dt>
          <dd>{{ ticket.num_people }}</dd>
        </div>
        }@if (ticket.salon_name) {
        <div>
          <dt>{{ "RESERVATION_TICKET.AREA" | translate }}</dt>
          <dd>{{ ticket.salon_name }}</dd>
        </div>
        }@if (ticket.service) {
        <div>
          <dt>{{ "RESERVATION_TICKET.SERVICE" | translate }}</dt>
          <dd>{{ ticket.service }}</dd>
        </div>
        }@if (ticket.pick_up) {
        <div>
          <dt>{{ "RESERVATION_TICKET.TRANSFER" | translate }}</dt>
          <dd>{{ "RESERVATION_TICKET.INCLUDED" | translate }}</dd>
        </div>
        }
      </dl>
    </section>
    <section class="ticket-stub">
      <span>{{ "RESERVATION_TICKET.REFERENCE" | translate }}</span
      ><strong>{{ ticket.reservation_id }}</strong>
      <p>{{ "RESERVATION_TICKET.SHOW_TICKET" | translate }}</p>
    </section>
    <section class="ticket-actions">
      @if (ticket.actions.confirm) {
      <button class="primary" type="button" (click)="choose('confirm')">
        {{ "RESERVATION_TICKET.CONFIRM" | translate }}
      </button>
      }@if (ticket.actions.edit) {
      <button type="button" (click)="choose('edit')">
        {{ "RESERVATION_TICKET.EDIT" | translate }}
      </button>
      }@if (ticket.actions.cancel) {
      <button class="danger" type="button" (click)="choose('cancel')">
        {{ "RESERVATION_TICKET.CANCEL" | translate }}
      </button>
      }<button class="quiet" type="button" (click)="print()">
        {{ "RESERVATION_TICKET.PRINT" | translate }}
      </button>
    </section>
  </article>
  } @if (action!=='view') {
  <section class="ticket-action-form">
    <button class="back" type="button" (click)="load()">
      ← {{ "RESERVATION_TICKET.BACK" | translate }}</button
    >@if (action==='edit') {
    <app-edit-reservation [ticketContext]="context"></app-edit-reservation>
    }@if (action==='cancel') {
    <app-cancel-reservation [ticketContext]="context"></app-cancel-reservation>
    }@if (action==='confirm') {
    <app-confirm-reservation
      [ticketContext]="context"
    ></app-confirm-reservation>
    }
  </section>
  } }
  <footer>
    <span>powered by <strong>SAGEL AI</strong></span>
    <div>
      <a
        href="https://sagel-ai.com/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        >{{ "RESERVATION_TICKET.PRIVACY" | translate }}</a
      ><a
        href="https://sagel-ai.com/terms-conditions/"
        target="_blank"
        rel="noopener noreferrer"
        >{{ "RESERVATION_TICKET.TERMS" | translate }}</a
      >
    </div>
  </footer>
</div>
